import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {EquipmentPointModel} from "../../../../../models/equipment-point.model";

@Component({
    selector: 'app-inspection-details-dialog',
    templateUrl: './inspection-details-dialog.component.html',
    styleUrls: ['./inspection-details-dialog.component.scss']
})
export class InspectionDetailsDialogComponent {
    point: EquipmentPointModel;

    constructor(
        public dialogRef: MatDialogRef<InspectionDetailsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { point: EquipmentPointModel }
    ) {
        this.point = data.point;
    }

    onClose(): void {
        this.dialogRef.close();
    }
}
